import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow-sm hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/80",
        outline: "text-foreground",
        // Suaves: fundo da cor a 12% e texto na cor. Para status e perfil em
        // tabela — o sólido grita demais repetido em toda linha.
        suave: "border-transparent bg-primary/12 text-primary",
        sucesso: "border-transparent bg-emerald-500/12 text-emerald-700 dark:text-emerald-400",
        aviso: "border-transparent bg-amber-500/12 text-amber-700 dark:text-amber-400",
        perigo: "border-transparent bg-red-500/12 text-red-600 dark:text-red-400",
        info: "border-transparent bg-sky-500/12 text-sky-700 dark:text-sky-400",
        neutro: "border-transparent bg-muted text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
